import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import React from "react";

export function ConfirmModal({cancelCallback, show, confirmCallback, title, description, fullWidth}) {
    if(!show) return <></>
    return (
    <Dialog onClose={() => { }} open={show} fullWidth={fullWidth}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
            {description}
        </DialogContent>
        <DialogActions className="confirm-buttons-group">
            <Button variant="outlined" color="primary" onClick={cancelCallback} style={{marginRight:"10px"}}>No</Button>
            <Button variant="contained" color="primary" onClick={confirmCallback}>Yes</Button>
        </DialogActions>
    </Dialog>)
}